import { Box, Image, Text, Button, Fade } from "@chakra-ui/react";

function DisplayImage(props) {
  return (
    <>
      {props.inputImage === null ? (
        <Box></Box>
      ) : (
        <Box
          display='flex'
          alignItems='center'
          justifyContent='space-evenly'
          flexDirection='row'
        >
          <Fade in={!!props.inputImage}>
            <Box mb={5}>
              <Text
                fontSize={{ base: "md", md: "lg", xl: "xl" }}
                fontWeight={600}
              >
                Uploaded Image
              </Text>
              <Image
                src={`data:image/png;base64,  ${props.inputImage}`}
                borderRadius={4}
                boxSize={{ base: "80%", md: "90%", xl: "100%" }}
              />
            </Box>
          </Fade>
          <Fade in={!!props.outputImage}>
            <Box pt={5}>
              <Text
                fontSize={{ base: "md", md: "lg", xl: "xl" }}
                fontWeight={600}
              >
                Masked Image
              </Text>

              <Image
                src={`data:image/png;base64,  ${props.outputImage}`}
                borderRadius={4}
                boxSize={{ base: "80%", md: "90%", xl: "100%" }}
              />
              <Button mt={2}>
                <a
                  download
                  href={`data:image/png;base64,  ${props.outputImage}`}
                >
                  Download Masked Image
                </a>
              </Button>
            </Box>
          </Fade>
        </Box>
      )}
    </>
  );
}

export default DisplayImage;
